import type { Messages } from "@prop/i18n";
import type en from "../en/breach";

export default {
  eyebrow: "Счёт остановлен",
  title: "Счёт остановлен — лимит потерян",
  lead: "Нарушено правило программы, торговля на этом счёте окончена. Открытые ордера отменены, все позиции закрыты по рынку.",
  rules: {
    max_loss: "Максимальная просадка: эквити дошло до нижней границы счёта",
    daily_loss: "Дневная просадка: эквити ниже сегодняшнего лимита",
    max_trade_loss: "Убыток сделки: одна сделка потеряла больше допустимого",
    consistency: "Консистентность: один день дал слишком большую долю прибыли",
    max_duration: "Время вышло: фаза прошла свой последний день",
    inactivity: "Неактивность: слишком долго не было сделок",
    max_trading_days: "Торговые дни закончились раньше цели",
  },
  limit: "Лимит",
  observed: "В момент нарушения",
  days: { one: "{count} день", few: "{count} дня", many: "{count} дней", other: "{count} дня" },
  at: "Когда",
  result: "Итог",
  balance: "Баланс {balance} из {start}",
  closedTitle: "Все позиции закрыты",
  closedNone: "Открытых позиций не было.",
  closing: "Закрываем позиции…",
  long: "Лонг",
  short: "Шорт",
  next: "Что дальше",
  reset: {
    title: "Сброс за {price}",
    note: "{pct} % от {base}, которые стоил счёт. Тот же счёт с начала: те же правила, тот же размер.",
    noteFixed: "Тот же счёт с начала: те же правила, тот же размер.",
    confirm: "Оплатить {price} и начать заново",
  },
  coupon: {
    title: "Новый счёт со скидкой {pct} %",
    note: "Ваш личный купон на следующую покупку. Действует до {date}, один раз.",
    copy: "Копировать",
    copied: "Скопировано",
    go: "Выбрать счёт",
    used: "Этот купон уже использован.",
  },
  free: {
    title: "Использовать бесплатный сброс",
    note: "Он был в вашей покупке. Активация: {fee}.",
    noteFree: "Он был в вашей покупке.",
    confirm: "Оплатить {fee} и начать заново",
    confirmFree: "Начать заново бесплатно",
  },
  back: "Назад",
  close: "Закрыть",
  history: "Перейти в историю",
  more: {
    one: "Остановлен ещё {count} счёт — он в истории.",
    few: "Остановлено ещё {count} счёта — они в истории.",
    many: "Остановлено ещё {count} счетов — они в истории.",
    other: "Остановлено ещё {count} счёта — они в истории.",
  },
  reasons: {
    already_restarted: "Этот счёт уже перезапущен.",
    not_failed: "Перезапустить можно только остановленный счёт.",
    reset_fee_due: "Оплата сброса пока недоступна. Напишите в поддержку.",
    bonus_activation_due: "Оплата активации пока недоступна. Напишите в поддержку.",
    no_reset_fee: "У этой программы нет платного сброса.",
  },
  log: {
    title: "История",
    lead: "Остановленные, пройденные и закрытые счета и чем закончился каждый.",
    rule: "Правило: {rule}",
    result: "Итог",
    details: "Подробнее",
    open: "Открыть",
  },
} satisfies Messages<typeof en>;
